import PanelItemsSection from "@/components/home/PanelItemsSection";
import DashboardNoteSection from "@/components/home/DashboardNoteSection";
import { useSidebarItems } from "@/context/SideBarItemsProvider";
import { useTitleBar } from "@/context/TitleBarProvider";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { LayoutDashboard } from "lucide-react";
import { useEffect } from "react";

export default function DashboardPage() {
  const { deserializedNavItems: sidebarItems } = useSidebarItems();
  const { setTitle, setIcon, setButtons } = useTitleBar();
  const { isAdmin } = useAdminStatus();

  useEffect(() => {
    setTitle("Dashboard");
    setIcon(<LayoutDashboard size={24} />);
    setButtons(null);
  }, [setTitle, setIcon, setButtons]);

  return (
    <div>
      <div className="mt-6">
        <PanelItemsSection />
      </div>

      <DashboardNoteSection isAdmin={isAdmin} />

      {!isAdmin && sidebarItems && sidebarItems.length === 0 &&
        <div className="mt-5">
          <div className="flex items-center gap-2 mb-5">
            <h2 className="font-medium whitespace-nowrap">You don't have any shortcuts yet; ask your admin to add some.</h2>
          </div>
        </div>
      }
    </div>
  );
}
